import { render, staticRenderFns } from "./SortingAnswer.vue?vue&type=template&id=d7b9442c"
import script from "./SortingAnswer.vue?vue&type=script&lang=js"
export * from "./SortingAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports